<template>
    <div>
        <Header :showInput="false" />
        <div class="mod-dial">
            <div class="mod-cont mod-payment-status">
                <div class="status-wrapper">
                    <div class="status-circle success">
                        <span></span>
                    </div>
                    <span class="status-message">{{ $t('PAY_SUC') }}</span>
                    <p class="status-text">
                        {{ $t('PAY_SUC_TXT') }}
                    </p>
                    <button class="close-modal btn-st-tr" @click="redirectToIntro()">{{ $t('PAY_MAIN') }}</button>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import { mapState, mapMutations } from "vuex";
import { PAYMENT_STATUS } from "../store/actions/pay";
import Header from "../components/Header";
export default {
  name: "PaySuccess",
  mounted() {},
  components: {
    Header
  },
  methods: {
    ...mapMutations([PAYMENT_STATUS]),
    redirectToIntro() {
      if (this.$route.path == "/main") this.INTRO_SET_PAGES();
      else this.$router.push({ path: "/main" });
    },
  }
}
</script>
